import * as React from 'react';
import { FormFieldInput } from '@cian/ui-kit';

import { ICadastreInputProps } from '../../types';
import { CADASTRE_INPUT_PLACEHOLDER } from '../../const';

export const CadastreInput: React.FC<ICadastreInputProps> = ({ value, error, onBlur, onChange }) => {
  return (
    <FormFieldInput
      type="text"
      invalid={Boolean(error)}
      onChange={onChange}
      onBlur={onBlur}
      errorMessage={error}
      value={value}
      placeholder={CADASTRE_INPUT_PLACEHOLDER}
      size="M"
    />
  );
};
